// extracted by mini-css-extract-plugin
export const card = "ComponentCard-module--card--1R3w9";
export const cover = "ComponentCard-module--cover--2EYw_";
export const horizontal = "ComponentCard-module--horizontal--19ttf";
export const vertical = "ComponentCard-module--vertical--3dspq";
export const authorList = "ComponentCard-module--authorList--31KJg";
export const ecClass = "ComponentCard-module--ecClass--2XKk0";
export const componentCover = "ComponentCard-module--componentCover--15nDS";